/*import {
  dns
} from './../../../providers/global.config';*/
import {
  NavParams
} from 'ionic-angular';
import {
  Component,
  ViewChild
} from '@angular/core';
import {
  OilChange,
  Provider,
  OilChangeInfo,
  TypeOil,
  DateInterval
} from '../model/index';

import {
  OilChangeService
} from '../../../providers/oil-change.service'

import {
  Subscription
} from 'rxjs/Subscription';
import {
  Observable
} from 'rxjs/Rx';
import {
  FileUploader
} from 'ng2-file-upload';
import {
  AlertController
} from 'ionic-angular/components/alert/alert-controller';
import {
  ModalController
} from 'ionic-angular/components/modal/modal-controller';
import {
  ViewController
} from 'ionic-angular/navigation/view-controller';
import {
  NavController
} from 'ionic-angular/navigation/nav-controller';
import {
  Events
} from 'ionic-angular/util/events';
import {
  ToastController
} from 'ionic-angular/components/toast/toast-controller';
import {
  VidangeForm
} from './vidange-form/vidange-form';

@Component({
  templateUrl: 'vidange.html'
})

export class VidangeComponent {
  public uploader: FileUploader = new FileUploader({
   // url: dns + 'upload'
  });
  currentuser: any;
  multipar: any;
  formData: FormData = new FormData();
  idVehicule: number = 0;
  listProviders: Provider[] = [];
  listOilChanges: OilChangeInfo[] = null;
  oilChange: OilChange = new OilChange();
  date: Date = new Date();
  showUpdate: boolean = false;
  idProvider = -1;
  index: number = 0;
  providerName: string = null;
  showProvider: boolean = false;
  checkboxFlag: boolean = true;
  showTypeEngineOil: boolean = false;
  showTypeOilF: boolean = false;
  showTypeAirF: boolean = false;
  showTypeFuelF: boolean = false;
  showTypeSeparatorF: boolean = false;
  matricule: string = null;
  indexFile: number = -1;
  item: any = null;
  subscriptionVehicule: Subscription;
  subscriptionUpload: Subscription;

  //dns: string = dns;
  dateIntervale: DateInterval = new DateInterval();
  operationTime: Date;
  endTime: Date;
  constructor(private oilChangeService: OilChangeService, public toastCtrl: ToastController, public events: Events, navParams: NavParams, public viewCtrl: ViewController, public alertCtrl: AlertController, private modalCtrl: ModalController) {
    this.idVehicule = navParams.data.idDevice.idVehicule;
    this.matricule = navParams.data.matricule;
  }
  ngAfterViewInit() {
    this.currentuser = JSON.parse(localStorage.getItem('currentuser'));
    this.uploader.authToken = this.currentuser.token;
    this.oilChangeService.getProviders("MAINTENANCE").subscribe(response => {
      this.listProviders = response;
    });


    this.listOilChanges = [];
    this.oilChangeService.getListOilChanges(this.idVehicule).subscribe(response => {
      this.listOilChanges = response;
      this.config();
      console.log(response)

    });

    this.subscriptionUpload = Observable.interval(100).subscribe(x => {
      this.uploader.onAfterAddingFile = (file) => {
        file.withCredentials = false;
      };
      if (this.item != null && this.indexFile >= 0)
        if (this.uploader.queue.length > 0) {
          if (this.uploader.queue[this.indexFile] != undefined && this.uploader.queue[this.indexFile].isSuccess) {
            this.item.isSuccess = false;
            this.item.remove();
            this.oilChangeService.readData(this.idVehicule, this.item.file.name).subscribe(response => {
              if (response.length > 0) {
                for (let i = 0; i < response.length; i++) {
                  this.listOilChanges.push(response[i]);
                }
              } else {}
            }, () => {});
          }
        }
    });
    
  }
  config() {
    this.operationTime = new Date();
    this.endTime = new Date();
    this.endTime.setFullYear(this.endTime.getFullYear() + 1);
    this.date = new Date();
    this.oilChange.quantity = 0;
    this.oilChange.cost = 0;
    this.oilChange.observation = null;
    if (this.listProviders.length > 0) {
      this.idProvider = this.listProviders[0].id;
      this.showProvider = false;
    } else {
      this.showProvider = true;
    }

    this.showUpdate = false;
    this.providerName = null;
    this.oilChange.engineOil = false;
    this.oilChange.typeEngineOil = 0;
    this.oilChange.oilF = false;
    this.oilChange.typeOilF = 0;
    this.oilChange.airF = false;
    this.oilChange.typeAirF = 0;
    this.oilChange.fuelF = false;
    this.oilChange.typeFuelF = 0;
    this.oilChange.separatorF = false;
    this.oilChange.typeSeparatorF = 0;
    this.showTypeEngineOil = false;
    this.showTypeOilF = false;
    this.showTypeAirF = false;
    this.showTypeFuelF = false;
    this.showTypeSeparatorF = false;
    this.oilChange.id = 0;
  }
  closeModal() {
    this.events.publish('Dismiss', null);
  }
  precisionRound(number: number, precision: number) {
    let factor = Math.pow(10, precision);
    return Math.round(number * factor) / factor;
  }
  uploadListener(item: any, indexFile: number) {
    this.item = item;
    this.indexFile = indexFile;

  }
  presentConfirm(oil: any, i: any) {
    let msg = 'Observation:' + oil.observation + '<br>';
    if (oil.engineOil)
      msg += 'H Moteur Type:' + oil.typeEngineOil + '<br> ';
    if (oil.oilF)
      msg += 'F Huile :' + oil.typeOilF + '<br> ';
    if (oil.fuelF)
      msg += 'F Carburant :' + oil.typeFuelF + '<br> ';
    if (oil.airF)
      msg += 'F Air Type :' + oil.typeAirF + '<br> ';
    if (oil.separatorF)
      msg += 'F Separator:' + oil.typeSeparatorF + '<br> ';

    let alert = this.alertCtrl.create({
      title: 'Informations',
      message: msg,

      buttons: [{
          text: 'Ok',
          role: 'cancel',
          handler: () => {

          }
        },
        {
          text: 'Modifier',
          role: '',
          handler: () => {
            this.update(oil)
          }
        }
      ]
    });
    alert.present();
    this.index = i;
  }
  update(oil: any) {
    let vidangemodal = this.modalCtrl.create(VidangeForm, {
      oil
    });
    vidangemodal.present();
    vidangemodal.onDidDismiss(data => {
      this.ngAfterViewInit();
      if (data)
        this.oilChangeService.update(data.oil, data.idProvider, data.providerName).subscribe((response) => {
          this.listOilChanges = this.listOilChanges.filter(oilChange => oilChange.id !== data.oil.id);
          this.listOilChanges.splice(this.index, 0, response);
          this.listProviders = this.listProviders.filter(provider => provider.id !== response.idProvider);
          let provider: Provider = new Provider();
          provider.id = response.idProvider;
          provider.name = response.providerName;
          this.listProviders.push(provider);
          this.config();
          let toast = this.toastCtrl.create({
            message: 'Vidange a été modifier avec succés',
            duration: 3000,
            position: 'top'
          });
          toast.present();
        });
    });
  }
  add() {
    let vidangemodal = this.modalCtrl.create(VidangeForm, {
      oil: this.oilChange
    });
    vidangemodal.present();
    vidangemodal.onDidDismiss(data => {
      this.ngAfterViewInit();
      this.oilChange.operationTime = this.date.getTime();
      if (data)

        this.oilChangeService.add(data.oil, this.idVehicule, data.idProvider, data.providerName).subscribe((response) => {
          this.listOilChanges.push(response);
          this.listProviders = this.listProviders.filter(provider => provider.id !== response.idProvider);
          let provider: Provider = new Provider();
          provider.id = response.idProvider;
          provider.name = response.providerName;
          this.listProviders.push(provider);
          this.config();
          let toast = this.toastCtrl.create({
            message: 'Vidange a été ajouter avec succés',
            duration: 3000,
            position: 'top'
          });
          toast.present();
        }, () => {});
      });
    }
  



}



// WEBPACK FOOTER //
// ./src/pages/gestion-park/vidange/vidange.ts